// used for customizing styles from host page
export const APP_CLASS_PREFIX = 'formaloo_app_builder'
